import { connect } from 'react-redux';

import Exam from './exam';
import {
    selectExam,
    onSubmitAnswer,
    onSubmitTest,
    onRestart,
    selectResult,
    onSubmitExamAnswer,
    onLoadExams,
} from '../../reducers/test.reducers';
import { onLoadCard, onLoadCardSucceeded, onExportContent } from '../../reducers/course.reducers';

const mapStateToProps = state => ({
  isLoading: state.tests.isLoadingQuestions,
  test: state.tests.selectedTest,
  questions: state.tests.questions,
  runStartedAt: state.tests.runStartedAt,
  correctAnswersCount: state.tests.correctAnswersCount,
  completed: state.tests.selectedTest && !!state.tests.selectedTest.endDate,
  tests: state.tests.previewTests,
  card: state.courses.cardForModal,
  testRun: state.tests.testRun,
  testRuns: state.tests.testRuns,
  selectedExam: state.tests.selectedExam,
});

const mapDispatchToProps = dispatch => ({
  loadTest: (test) => {
    // dispatch(onLoadExams())
    dispatch(selectExam(test));
  },
  loadExams: test => dispatch(onLoadExams(test)),
  loadResult: (test) => {
    dispatch(selectResult(test));
  },
  onSubmitAnswer: (question, answersTicked, testRunId, examId) => {
    dispatch(onSubmitExamAnswer({ question, answersTicked, testRunId, examId }));
  },
  onSubmitTest: () => dispatch(onSubmitTest()),
  onRestart: () => dispatch(onRestart()),
  onLoadCard: options => dispatch(onLoadCard(options)),
  onCloseLinkedCard: () => dispatch(onLoadCardSucceeded({ card: null })),
  onExportContent: url => dispatch(onExportContent(url)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Exam);



// WEBPACK FOOTER //
// ./src/app/main/test/exam.container.js